import React, { Component } from "react";

import Logo from "../../../components/atoms/Logo";
import Label from "../../../components/atoms/Label";
import FormLogin from "./FormLogin";

import { connect } from "react-redux";
import ActionLogin from "../../../redux/actions/Login";
import { SET_ERROR_STATE, RESET_STATUS_STATE } from "../../../utils/constants/actionTypes";
import RefreshToken from "../../../redux/actions/RefreshToken";
import history from "../../../history";
import { Redirect } from "react-router-dom";

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {};
	}

	prosesLogin = ({ email, password }) => {
		// Validasi
		if (email && password) {
			this.props.ActionLogin({ email, password });
		} else {
			this.props.SetError("Surel dan Kata sandi tidak boleh kosong");
		}
	};

	componentDidMount = () => {
		this.props.ResetError();
		this.props.RefreshToken((ClientID) => {}, false);

		document.title = "KlikCair - Login Pinjaman";
	};

	chekLogin = () => {
		if (this.props.isLogin) {
			return <Redirect to="/dashboard" />;
		} else {
			return (
				<>
					<div className="login-wrapper d-flex align-items-center justify-content-center flex-column">
						<Logo />
						<div className="container">
							<div className="row mt-5 align-items-center">
								<div className="col-12 col-md-6">
									<img className="image-karakter" src="./img/login/login-borw.png" alt="Karakter Login Borrower" />

									<Label type="title" className="label-kc-mb mt-3 mb-1" value="Selamat Datang di KlikCair" />
									<Label type="paragraph" value="Ajukan pinjaman untuk solusi pendanaan bisnis Anda." />
								</div>

								<div className="col-12 col-md-6 mt-sm-0 mt-4 mb-5">
									<div className="box-login-wrapper">
										<FormLogin {...this.props} onSubmit={this.prosesLogin} />
									</div>
								</div>
							</div>
						</div>
					</div>

					<div className="footer-login d-flex justify-content-center align-items-center flex-column">
						<small>Butuh bantuan ? Hubungi (021) 80627908 atau kirim email ke info@klikcair.com</small>
						<small>Hari Senin sampai Jumat 09.00 - 17.00 WIB</small>
					</div>
				</>
			);
		}
	};

	render() {
		return <div>{this.chekLogin()}</div>;
	}
}

const mapStateToProps = (state) => {
	return {
		status: state.statusState,
		isLogin: state.statusLogin.login,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		ResetError: () => {
			dispatch({ type: RESET_STATUS_STATE });
		},
		SetError: (msgErr) => {
			dispatch({ type: SET_ERROR_STATE, payload: msgErr });
		},
		ActionLogin: (data) => {
			dispatch(ActionLogin(data));
		},
		RefreshToken: (cb, loading) => {
			dispatch(RefreshToken(cb, loading));
		},
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);
